export const environment = {
  production: false,
  dbName: 'sapore-poll-pwa',
  dbVersion: 2,
  URLAPI: 'https://api-saporeconecta-dev.sapore.com.br/',
};
